// components/products/sections/ManufacturingSection.jsx - Updated
import React from "react";
import { Factory } from "lucide-react";

const ManufacturingSection = ({
  formData,
  handleChange,
  errors,
  CRAFT_TYPE_ENUM,
  TECHNIQUE_ENUM,
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <Factory className="w-5 h-5 text-gray-400 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">
          Manufacturing Details
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Karigar Code *
          </label>
          <input
            type="text"
            name="karigarCode"
            value={formData.karigarCode}
            onChange={handleChange}
            className={`w-full px-3 py-2 border ${
              errors.karigarCode ? "border-red-300" : "border-gray-300"
            } rounded-md focus:ring-blue-500 focus:border-blue-500`}
            placeholder="Enter karigar code"
          />
          {errors.karigarCode && (
            <p className="mt-1 text-sm text-red-600">{errors.karigarCode}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Batch Number
          </label>
          <input
            type="text"
            name="manufacturing.batchNumber"
            value={formData.manufacturing?.batchNumber || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder="Manufacturing batch number"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Craft Type
          </label>
          <select
            name="craftType"
            value={formData.craftType}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select Craft Type</option>
            {CRAFT_TYPE_ENUM.map((type) => (
              <option key={type} value={type}>
                {type.replace(/_/g, " ")}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Technique
          </label>
          <select
            name="technique"
            value={formData.technique}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select Technique</option>
            {TECHNIQUE_ENUM.map((tech) => (
              <option key={tech} value={tech}>
                {tech}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Origin
          </label>
          <input
            type="text"
            name="manufacturing.origin"
            value={formData.manufacturing?.origin || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder="e.g., Jaipur, Kolkata"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Production Date
          </label>
          <input
            type="date"
            name="manufacturing.productionDate"
            value={
              formData.manufacturing?.productionDate
                ? new Date(formData.manufacturing.productionDate)
                    .toISOString()
                    .split("T")[0]
                : ""
            }
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ManufacturingSection;
